export const loadingStyle = {
  mb: 2,
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  height: "300px",
  backgroundColor: "gray",
  borderRadius: "10px",
  overflow: "hidden",
  position: "relative",
};

export const bannerStyles = {
  mb: 2,
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  height: "300px",
  backgroundColor: "gray",
  borderRadius: "10px",
  overflow: "hidden",
  position: "relative",
};

export const bannerPreviewStyles = {
  mb: 2,
  width: "75%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  height: "225px",
  backgroundColor: "gray",
  borderRadius: "10px",
  overflow: "hidden",
  position: "relative",
};

export const bannerPreviewImageStyles = (infoImage) => ({
  width: "100%",
  height: "100%",
  transform: "scale(1.2)",
  backgroundImage: `url(${infoImage})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  transition: "transform 0.5s ease",
  "&:hover": {
    transform: "scale(1.2)",
  },
});

export const imageStyles = (infoImage) => ({
  width: "100%",
  height: "100%",
  transform: "scale(1.1)",
  backgroundImage: `url(${infoImage})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  transition: "transform 0.5s ease",
  "&:hover": {
    transform: "scale(1.2)",
  },
});

export const expandIcon = {
  position: "absolute",
  top: 8,
  right: 8,
  bgcolor: "white",
  color: "gray",
  zIndex: 1,
  "&:hover": {
    transform:"scale(1.2)",
  },
};

export const iconButtonStyles = {
  position: "absolute",
  top: 10,
  right: 10,
  color: "#fff",
  backgroundColor: "rgba(0, 0, 0, 0)",
  "&:hover": {
    transform:"scale(1.2)",
    backgroundColor: "rgba(0, 0, 0, 0)",
  },
};

export const dialogContentStyles = {
  position: "relative",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "rgba(0, 0, 0, 0.3)",
};

export const placeholderContainerStyles = {
  mb: 2,
  width: "100%",
  height: "300px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#e8e8e8",
  borderRadius: "10px",
};

export const placeholderStyles = {
  textAlign: "center",
  color: "#333",
  fontSize: "48px",
  fontWeight: "600",
  padding: "0 20px",
};
